import React, { useState, useEffect, memo } from "react";
import { View, StyleSheet, Modal, TouchableOpacity } from "react-native";
import Text from "@components/AppText";
import CloseIcon from "@assets/svg/CloseIcon";
import colors from "@constants/color";
import WelcomeCLToCLGraphic from "@assets/svg/WelcomeCLToCLGraphic";
import { useSelector } from "react-redux";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { getLeaderDetails } from "@services/api";

import t from "@constants/localization";

const PATH = "components/WelcomeCLToCL";

const WelcomeCLtoCL = memo(() => {
  const [shouldVisible, setShouldVisible] = useState(false);
  const [leaderName, setLeaderName] = useState("");

  const { user = {}, tracking_info } = useSelector((state) => state.auth);

  const userName = user.name ? user.name.split(" ")[0] : "";

  const handleClose = async () => {
    setShouldVisible(false);
    await AsyncStorage.removeItem("showCLToCLWelcome");
    await AsyncStorage.removeItem("showWelcomeTLtoTlToNew");
  };

  const { teamLeaderId = "" } = tracking_info || {};

  useEffect(() => {
    (async () => {
      try {
        if (teamLeaderId) {
          const { data } = await getLeaderDetails(teamLeaderId);
          if (data.result.name) {
            setLeaderName(data.result.name);
          }

          const value = await AsyncStorage.getItem("showCLToCLWelcome");
          const showMsgToNewUser = await AsyncStorage.getItem(
            "showWelcomeTLtoTlToNew",
          );

          if (value && showMsgToNewUser) {
            if ((teamLeaderId, showMsgToNewUser)) {
              setShouldVisible(true);
            }
          }
        }
      } catch (e) {
        console.log(e);
      }
    })();
  }, [teamLeaderId, tracking_info]);

  if (!teamLeaderId) return <></>;

  return (
    <Modal
      statusBarTranslucent
      navigationBarTranslucent
      transparent
      visible={shouldVisible}
      onRequestClose={handleClose}
    >
      <View style={styles.container}>
        <View style={styles.wrapper}>
          <View>
            <View
              style={[styles.beLikeRow, { justifyContent: "space-between" }]}
            >
              <View>
                <Text bold fontType="head3">
                  {t(`${PATH}/welcome`, { userName })}
                </Text>
              </View>
              <TouchableOpacity
                testID="wcl-close-button"
                style={{
                  padding: 10,
                }}
                onPress={handleClose}
              >
                <CloseIcon />
              </TouchableOpacity>
            </View>
          </View>
          <View style={{ paddingVertical: 10 }}>
            <Text
              fontType="head3"
              style={{
                color: "rgba(0, 0, 0, 0.56)",
              }}
            >
              {t(`${PATH}/welcomeMsg`, { leaderName })}
            </Text>
          </View>
          <View
            style={{
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <WelcomeCLToCLGraphic />
          </View>
          <TouchableOpacity
            testID="wcl-start-button"
            style={styles.btn}
            onPress={handleClose}
          >
            <Text
              fontType="head3"
              bold
              style={{
                color: "#fff",
                textAlign: "center",
              }}
            >
              {t(`${PATH}/letsStart`)}
            </Text>
          </TouchableOpacity>
        </View>
      </View>
    </Modal>
  );
});

const styles = StyleSheet.create({
  beLikeRow: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
  },
  container: {
    flex: 1,
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 20,
  },
  wrapper: {
    padding: 20,
    backgroundColor: "#fff",
    elevation: 6,
  },
  btn: {
    backgroundColor: colors.primary,
    padding: 20,
    borderRadius: 10,
    marginVertical: 10,
  },
});

export default WelcomeCLtoCL;
